import { useEffect, useState } from "react";

import { Checkbox, Empty, Loading, Message } from "@components";

import { ForEach } from "@components/control-statements";
import { OlgaEnvironmentsAPI } from "@providers/OlgaEnvironmentsAPI";
import styles from "@styles/forms-flow/orders.module.scss";

export const OriginForm = ({ node, onChange, onSave }) => {
  const [availableOrigins, setAvailableOrigins] = useState([]);
  const [origins, setOrigins] = useState(node?.data?.origins || []);
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);

  const getFreshNode = () => {
    return {
      ...node,
      data: {
        ...node?.data,
        origins: origins,
        quantity: 0,
      },
    };
  };

  useEffect(() => {
    loadSources();
  }, []);

  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [origins]);

  const loadSources = async () => {
    setLoading(true);
    const sourcesResponse = await OlgaEnvironmentsAPI.getAvailableSources();
    const externalSourcesResponse =
      await OlgaEnvironmentsAPI.getExternalSourcesConfigs();

    setSources(sourcesResponse.getData());
    setAvailableOrigins(externalSourcesResponse.getData());

    setLoading(false);
  };

  const getSourceName = (sourceAlias) => {
    const source = sources.find((s) => s.alias == sourceAlias);
    return source ? source.name : "Desconhecido";
  };

  const ExternalSourceGroup = ({ availableOrigins }) => {
    return (
      <ForEach
        items={Object.entries(availableOrigins || {})}
        render={([sourceAlias, externalSources]) => {
          return (
            <>
              <p className={styles.label}>{getSourceName(sourceAlias)}</p>
              <ExternalSourceGroupItems externalSources={externalSources} />
            </>
          );
        }}
      />
    );
  };

  const ExternalSourceGroupItems = ({ externalSources }) => {
    return (
      <ForEach
        items={Object.entries(externalSources || {})}
        render={([externalSource, config]) => (
          <Checkbox
            label={config?.correct || externalSource}
            checked={origins.includes(externalSource)}
            className={"mb-10"}
            onChange={() => {
              if (origins.includes(externalSource)) {
                setOrigins(origins.filter((f) => externalSource != f));
              } else {
                setOrigins([...origins, externalSource]);
              }
            }}
          />
        )}
      />
    );
  };

  return (
    <>
      {!!loading && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}

      {!loading &&
        (availableOrigins ? (
          <>
            <Message className="mb-20">
              O usuário deve ter ao menos um pedido em:
            </Message>
            <p className={styles.label}>Selecione as origens</p>
            <div className={styles.scrollContainerWithFooter}>
              <ExternalSourceGroup availableOrigins={availableOrigins} />
            </div>
          </>
        ) : (
          <Empty
            title="Nenhuma origem encontrada"
            image={<i className="far fa-arrows-split-up-and-left"></i>}
          />
        ))}
    </>
  );
};
